import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useHook from './useHook'
import CustomerAreaCascaderText from './CustomerAreaCascaderText.vue'

const __default__ = { name: 'CustomerAreaCascader' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    appId: {},
    deptInfoId: {},
    type: {},
    view: { type: Boolean },
    multiple: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n()

const props = __props
const { customerAreaEnum } = useHook(props.appId, props.deptInfoId)

const attrs = computed(() => ({
  type: props.type,
  changeOnSelect: true,
  multiple: (props.type && props.appId === 'cos_lbu') || props.multiple, // 只有 search 类型 且为 cos_lbu 才支持多选
  maxTagCount: props.appId === 'cos_lbu' ? 'responsive' : undefined,
  fieldNames: props.appId === 'cos_lbu' ? { label: 'name', value: 'id' } : { label: 'label', value: 'id' }
}))

return (_ctx: any,_cache: any) => {
  const _component_CosCascader = _resolveComponent("CosCascader")!

  return (_ctx.view)
    ? (_openBlock(), _createBlock(CustomerAreaCascaderText, _mergeProps({ key: 0 }, attrs.value, {
        deptInfoId: _ctx.deptInfoId,
        appId: _ctx.appId,
        view: _ctx.view
      }), null, 16, ["deptInfoId", "appId", "view"]))
    : (_openBlock(), _createBlock(_component_CosCascader, _mergeProps({ key: 1 }, attrs.value, {
        options: _unref(customerAreaEnum),
        placeholder: _unref(t)('common.pleaseSelect'),
        allowClear: ""
      }), null, 16, ["options", "placeholder"]))
}
}

})